import React from "react";
import { useTranslation } from "react-i18next";
import { config } from "@/config";
import SidebarNav from "@imminently/decisively-ui/SidebarNav";

export const AppInfo = () => {
  const { t } = useTranslation();
  const sidebarNavContext = SidebarNav.useSidebarNav();
  const collapsed = Boolean(sidebarNavContext?.collapsed);

  if (collapsed) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-light">
        <span className="font-semibold">Version</span> {config.APP_VERSION}#{config.APP_HASH}
      </p>
      <p className="text-xs text-muted-light">
        <span className="font-semibold">Released</span> {config.APP_DATE}
      </p>
      <p className="text-xs text-muted-light">
        © {new Date().getFullYear()} {t('powered_by_decisively')}
      </p>
    </div>
  );
};
